<label for="name" class="form-label" translate="field.name"></label>
<div [formGroup]="registerForm" class="input-group has-validation">
  <input type="text" class="form-control" id="name" formControlName="name"
         [ngClass]="{ 'is-invalid': isInvalid() }"
         data-lpignore='true'
  />
  <span class="input-group-text"><i class="fas fa-address-book mx-2"></i></span>
  <div class="invalid-feedback" translate="signIn.nameRequired"></div>
</div>
